import { render, staticRenderFns } from "./DeleteEvent.vue?vue&type=template&id=2706cfc4&"
import script from "./DeleteEvent.vue?vue&type=script&lang=ts&"
export * from "./DeleteEvent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DeleteEvent.vue"
export default component.exports